<template>
  <carousel :navigationNextLabel="null" :navigationPrevLabel="null"
            :perPage="1" :paginationEnabled="true" :navigationEnabled="true" :loop="true"
            :perPageCustom="[[320, 1], [1199, 1]]"
  >
    <slide v-for="(i , index) in data" :key="index">
      <div class="box">
        <div class="img"><img :src="require('../../assets/Home/'+i.img)" alt=""></div>
      </div>

    <div class="buttons">
      <button class="label-next"></button>
      <button class="label-perv"></button>
    </div>
    </slide>
  </carousel>
</template>

<script>
import {Carousel, Slide} from 'vue-carousel';

export default {
  name: "the-home-carousel",
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      data: [
        {link: '', img: 'slider.jpg'},
        {link: '', img: 'slider2.jpg'},
        {link: '', img: 'slider3.jpg'},
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.img {
  width: 100% !important;

  img {
    width: 80% !important;
    height: 90vh;
    object-fit: fill;
  }
}

@media (max-width: 600px) {
  .img img{
    // object-fit: scale-down;

    width: 100% !important;
    height: 45vh;
  }
}
</style>
<style>
.VueCarousel-inner{
  gap:0 !important;
}
</style>
